import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { logError } from "@/lib/log";

// One-tap hug when the member hits a Skill of the Day streak milestone
export const SupporterStreakHug = ({ token, name }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/supporters/view/${token}/streak-hug`).then((r) => setD(r.data)).catch((e) => logError("Streak hug load failed:", e)); }, [token]);
  useEffect(() => { if (d?.available && window.location.hash === "#streak-hug") document.getElementById("streak-hug")?.scrollIntoView({ behavior: "smooth", block: "center" }); }, [d]);
  if (!d?.available) return null;
  const send = async () => {
    setBusy(true);
    try { await api.post(`/supporters/view/${token}/streak-hug`); setD({ ...d, sent: true }); toast.success(`Hug sent to ${name} 🤗`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div id="streak-hug" className="mm-card p-5 flex flex-wrap items-center gap-4 mm-fade-up" data-testid="supporter-streak-hug">
      <div className="text-4xl" aria-hidden>🎉</div>
      <div className="flex-1 min-w-[12rem]">
        <div className="font-semibold text-lg" data-testid="supporter-streak-hug-title">{name} reached a {d.milestone}-day skill streak!</div>
        <p className="text-sm text-mm-muted">They've tried a new coping skill every day. A little hug from you would mean a lot.</p>
      </div>
      {d.sent
        ? <span className="mm-chip pointer-events-none" data-testid="supporter-streak-hug-sent">🤗 Hug sent</span>
        : <button onClick={send} disabled={busy} className="mm-btn" data-testid="supporter-streak-hug-btn">{busy ? <Loader2 size={16} className="animate-spin" /> : "🤗"}Send a hug</button>}
    </div>
  );
};
